export const RouteNames = {
  HOME: '/',
  LOGIN: '/login',
  AZURE_CALLBACK: '/public/oauth',
  CIAM_CALLBACK: '/public/coauth',
  NOT_FOUND: '*',

  // Dashboard routes
  DASHBOARD_STORAGE: '/dashboard/storage-overview',
  DASHBOARD_TRANSPORT: '/dashboard/transport-overview',
  DASHBOARD_SERVICE_USERS: '/dashboard/service-users',
  DASHBOARD_MAPPING: '/dashboard/mapping'
} as const;

export type RouteNames = (typeof RouteNames)[keyof typeof RouteNames];
